<template>
  <div class="colors" :style="{ top: showTop ? -288 : 28 }">
    <div class="content">
      <div
        class="inner"
        v-for="(item, index) in colors"
        :class="{ selected: item === selectColor }"
        :index="index"
        @click="toSetColor(item)"
      >
        <span :style="{ backgroundColor: item }"></span>
      </div>
    </div>
    <div class="reset" @click="toReset">Reset to default</div>
  </div>
</template>

<script>
export default {
  name: 'colors',
  props: {
    type: {
      type: String,
      default: 'font'
    },
    showTop: {
      type: Boolean,
      default: true
    },
    defaultColor: {
      type: String,
      default: ''
    }
  },
  mounted() {
    // 原实现先按 type 赋值再被 defaultColor 无条件覆盖（defaultColor 缺省为 ''，
    // 等于永远清空选中高亮）；改为缺省时回落到 type 对应的默认色
    this.selectColor = this.defaultColor || (this.type == 'font' ? '#33475b' : 'rgb(255, 255, 255)')
  },
  methods: {
    toSetColor(color) {
      this.selectColor = color
      this.$emit('setColor', this.selectColor, this.type)
    },
    toReset() {
      if (this.type == 'font') {
        this.selectColor = '#33475b'
      } else {
        this.selectColor = 'rgb(255, 255, 255)'
      }
      this.$emit('setColor', this.selectColor, this.type)
    }
  },
  data() {
    return {
      selectColor: '#33475b',
      colors: [
        '#33475b',
        'rgb(255, 2, 1)',
        'rgb(255, 153, 2)',
        'rgb(255, 255, 4)',
        'rgb(0, 255, 3)',
        'rgb(0, 255, 255)',
        'rgb(6, 0, 255)',
        'rgb(154, 0, 255)',
        'rgb(255, 0, 255)',
        'rgb(255, 255, 255)',
        '#F4CCCC',
        '#FCE5CD',
        '#FFF2CC',
        '#D9EAD3',
        '#D0E0E3',
        '#CFE2F3',
        '#D9D2E9',
        '#EAD1DC',
        '#FAFAFA',
        '#EA9999',
        '#F9CB9C',
        '#FFE599',
        '#B6D7A8',
        '#A2C4C9',
        '#9FC5E8',
        '#B4A7D6',
        '#D5A6BD',
        '#EEEEEE',
        '#E06666',
        '#F6B26B',
        '#FFD966',
        '#93C47D',
        '#76A5AF',
        '#6FA8DC',
        '#8E7CC3',
        '#C27BA0',
        '#CCCCCC',
        '#CC0201',
        '#E69138',
        '#F1C233',
        '#69A84F',
        '#45818E',
        '#3D85C6',
        '#674EA7',
        '#A64D79',
        '#999999',
        '#990100',
        '#B45F06',
        '#BF9002',
        '#37761D',
        '#134F5C',
        '#0C5394',
        '#351C75',
        '#741B47',
        '#666666',
        '#660000',
        '#783F04',
        '#7F6001',
        '#274E13',
        '#0C343D',
        '#073763',
        '#20124D',
        '#4C1130'
      ]
    }
  }
}
</script>

<style scoped lang="less">
.colors {
  position: absolute;
  width: 306px;
  height: 282px;
  padding: 16px;
  left: 0;
  top: 28px;
  z-index: 20;
  border-radius: 3px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  background-color: #fff;
  border: 1px solid #cbd6e2;
  .content {
    display: flex;
    flex-wrap: wrap;
    .inner {
      width: 30px;
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 2px;
      &:hover {
        span {
          box-shadow: 0 0 0 2px rgb(127, 209, 222);
          width: 28px;
          height: 28px;
        }
      }
      span {
        display: inline-block;
        border: 1px solid rgba(0, 0, 0, 0.2);
        border-radius: 2px;
        width: 25px;
        height: 25px;
      }
    }
    .selected {
      span {
        box-shadow:
          rgb(255 255 255) 0px 0px 0px 1px,
          rgb(0 164 189) 0px 0px 0px 3px;
      }
      &:hover {
        span {
          box-shadow:
            rgb(255 255 255) 0px 0px 0px 1px,
            rgb(0 164 189) 0px 0px 0px 3px;
          width: 25px;
          height: 25px;
        }
      }
    }
  }

  .reset {
    background-color: #eaf0f6;
    border: 1px solid #cbd6e2;
    color: #506e91;
    font-size: 14px;
    font-family: OpenSans;
    width: 100%;
    margin-top: 12px;
    border-radius: 2px;
    line-height: 32px;
    &:hover {
      background-color: #f5f8fa;
    }
  }
}
</style>
